var React = require('react');

function ExpandIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.15039","y":"1.33374","width":"39","height":"39","rx":"19.5","fill":"white","key":0}),React.createElement("rect",{"x":"1.15039","y":"1.33374","width":"39","height":"39","rx":"19.5","stroke":"#B9BCCC","key":1}),React.createElement("path",{"d":"M26.6504 17.8337L20.6504 23.8337L14.6504 17.8337","stroke":"#162154","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ExpandIcon.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = ExpandIcon;

ExpandIcon.default = ExpandIcon;
